import { getters } from "@/constants/state";

export default {
  [getters.DOMAIN_GETTER]: (state) => state.domain,
  [getters.DOMAIN_LOCATION_ID_GETTER]: (state) =>
    state.domain?.horeca_location_id,
  [getters.DOMAIN_LOCATION_NAME_GETTER]: (state) =>
    state.domain?.description,
};
